export default __webpack_public_path__ + "static/media/facility_04_2.ab1b9483.png";